import * as types from "../action/ActionType";
import { OFFSET_INITIAL } from "../store/InitialStore";
export default function PageReducer(state = OFFSET_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.PAGE_OFFSET:
      return (state = payload);
    default:
      return state;
  }
}
